<div class="gallery-item-wrapper d-lg-flex">
    <div
        (mouseout)="onGalleryItemMouseLeave()"
        (mouseover)="onGalleryItemHover()"
        class="col-md-12 col-lg-7 gallery-item"
    >
        <button
            (click)="previewLeft()"
            *ngIf="getSelectedAssetIndex() !== 0"
            class="visually-hidden"
            tabindex="0"
        >
            Previous Gallery Item
        </button>
        <div *ngIf="resource.selectedAsset.isVideo()">
            <app-media-gallery-buttons
                (leftAction)="previewLeft()"
                (rightAction)="previewRight()"
            ></app-media-gallery-buttons>
            <app-video
                [isCautionFlagContainerDisplayed]="isCautionFlagContainerDisplayed"
                [cautionFlagButtonName]="cautionFlagButtonName"
                [gtmVideoJsInfo]="gtmVideoJsInfo"
                [muxData]="muxData"
                [videoMedia]="selectedMedia"
            ></app-video>
        </div>
        <div *ngIf="resource.selectedAsset.isAudio()" class="audio-item">
            <app-media-gallery-buttons
                (leftAction)="previewLeft()"
                (rightAction)="previewRight()"
            ></app-media-gallery-buttons>
            <app-audio
                (audioPlayerReady)="onAudioPlayerReady($event)"
                [audioMedia]="selectedMedia"
                [gtmVideoJsInfo]="gtmVideoJsInfo"
                [muxData]="muxData"
                class="audio media-gallery"
            >
            </app-audio>
        </div>
        <div *ngIf="resource.selectedAsset.isDocument()">
            <app-media-gallery-buttons
                (leftAction)="previewLeft()"
                (rightAction)="previewRight()"
            ></app-media-gallery-buttons>
            <app-document-preview [documentMedia]="selectedMedia"> </app-document-preview>
        </div>
        <div *ngIf="resource.selectedAsset.isImage()">
            <app-media-gallery-buttons
                (leftAction)="previewLeft()"
                (rightAction)="previewRight()"
            ></app-media-gallery-buttons>
            <app-image-preview [imageMedia]="selectedMedia"></app-image-preview>
        </div>
        <div *ngIf="resource.selectedAsset.isGenericInteractive()">
            <app-media-gallery-buttons
                (leftAction)="previewLeft()"
                (rightAction)="previewRight()"
            ></app-media-gallery-buttons>
            <app-generic-interactive-preview [interactiveAsset]="resource.selectedAsset">
            </app-generic-interactive-preview>
        </div>
    </div>
    <div class="col-lg-5 gallery-item-info">
        <button
            (click)="previewRight()"
            *ngIf="
                getSelectedAssetIndex() !== resource.assets.length - 1 &&
                !isCautionFlagContainerDisplayed
            "
            class="visually-hidden"
            tabindex="0"
        >
            Next Gallery Item
        </button>
        <div class="item-count">
            Resource {{ getSelectedAssetIndex() + 1 }} of
            {{ resource.assets.length }}
        </div>
        <div class="item-title">
            {{ resource.selectedAsset.title | safeTruncate: 80 }}
        </div>
        <div
            [innerHTML]="resource.selectedAsset.description || '' | bypassSecurity: 'html'"
            class="item-description"
        ></div>
        <p *ngIf="resource.selectedAsset.medias.length > 1" class="available-language">
            <app-language-selector
                (selectedItemChange)="changeLanguage($event)"
                [items]="resource.selectedAsset.medias"
                [selectedItem]="selectedMedia"
            ></app-language-selector>
        </p>
        <p *ngIf="selectedMedia.download.is_downloadable && !isAddonView" class="action-btn">
            <a
                (click)="download($event)"
                aria-controls="nav-download"
                aria-selected="false"
                href="#"
                class="nav-item nav-link ms-auto download selenium-download"
            >
                <i class="fas fa-download"></i>
                Download
            </a>
        </p>
        <p *ngIf="selectedMedia.hasTranscript()" class="action-btn">
            <a
                (click)="downloadTranscript($event)"
                aria-controls="nav-transcript"
                aria-selected="false"
                class="nav-item nav-link ms-auto download selenium-transcript"
                href="#"
                rel="noopener noreferrer"
                target="_blank"
            >
                <i class="fas fa-bars fa-fw pr4"></i>
                Transcript
            </a>
        </p>
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="gallery-carousel-wrapper px-4">
            <app-carousel2
                [alwaysShowArrows]="false"
                [innerArrows]="true"
                [itemWidth]="230"
                gtmPrefix="resource"
                height="210"
            >
                <app-carousel-item2 *ngFor="let item of resource.assets; let i = index" class="">
                    <div
                        tabindex="0"
                        (click)="onGalleryItemClick(item, $event)"
                        (keydown)="onGalleryItemClick(item, $event, true)"
                        [ngClass]="{ 'item-hover': resource.selectedAsset === item }"
                        class="card gtm-resource-gallery-asset selenium-asset-card-{{ i + 1 }}"
                    >
                        <div class="card-header-wrapper">
                            <div class="card-header">
                                <!-- HTML Fragment -->
                                <div
                                    *ngIf="
                                        item.isHTMLFragment() && !!item.selectedMedia?.posterImage
                                    "
                                    [innerHtml]="item.selectedMedia.htmlContent"
                                    class="html-fragment"
                                ></div>
                                <!-- Support material with poster image -->
                                <img
                                    *ngIf="!!item.selectedMedia?.posterImage"
                                    alt="{{ item.selectedMedia.posterImage.altText }}"
                                    class="card-header-content"
                                    src="{{ item.selectedMedia.posterImage.itsURL }}"
                                />
                                <!-- Support material without a poster image. Display a placeholder image. -->
                                <img
                                    *ngIf="!item.isHTMLFragment() && !!item?.posterImage"
                                    alt="{{ item.title }}"
                                    class="card-header-content"
                                    src="{{ placeholderImg }}"
                                />
                            </div>
                        </div>
                        <div class="card-body">
                            <h5 class="card-title">
                                {{ item.title | safeTruncate: 35 }}
                            </h5>
                        </div>
                        <div class="d-flex footer p-3 flex-row flex-nowrap justify-content-between">
                            <app-icon [type]="item.mediaType" class="media-icon"></app-icon>
                            <div class="caution-content" *ngIf="item.contentFlags.length">
                                <app-icon
                                    *ngIf="item.contentFlags && assetContainsNewCautionFlags(item)"
                                    [type]="'Exclamation-Circle'"
                                    class="media-icon exclamation"
                                ></app-icon>
                            </div>
                        </div>
                    </div>
                </app-carousel-item2>
            </app-carousel2>
        </div>
    </div>
</div>
